import React from "react";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import useSnackbar from "../../../hooks/useSnackbar";
import {
  getTransactionCommonSytemNotes,
  getTransactionShippingAddress,
} from "../../../api/transaction-type";
import {
  commonSystemNotesTable,
  invoiceActiveWorkfowTables,
  invoiceAppliedRulesTable,
  invoiceSystemNotesTable,
  invoiceWorkflowHistoryTables,
  salesOrderActiveWorkfowTables,
  salesOrderAppliedRulesTable,
  salesOrderSystemNotesTable,
  salesOrderWorkflowHistoryTables,
} from "../../../config/grid-column-defs";
import AgGridPaginatedTable from "../../../components/AgGridPaginatedTable";

import { slugMap } from "../../../config/slug-config";
import { useParams } from "react-router-dom";
import {
  Box,
  Grid,
  Tabs,
  Tab,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
  FormControlLabel,
  Checkbox,
  FormGroup,
  Stack,
  Button,
} from "@mui/material";
import TabPanel from "../../../components/TabPanel";

export default function DepositSystemInformation() {
  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);
  const pageDetail = slugMap[params.slug];
  const [rowData, setRowData] = useState([]);

  // const [tableRefreshCount, setTableRefreshCount] = useState(0);
  // function refreshTable () {
  //     setTableRefreshCount(prev => prev + 1);
  // }

  // useEffect(() => {
  //   if (user.token) {
  //     getTransactionShippingAddressData();
  //   }
  // }, [user.token]);

  async function getTransactionShippingAddressData() {
    setLoading(true);
    try {
      const { data } = await getTransactionShippingAddress(user.token, {
        id: params.docNo,
      });
      setRowData(data.data.data);
      setLoading(false);
      return { rows: data.data.data, total: data.data.total, error: false };
    } catch (error) {
      console.log(error);
      setLoading(false);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      setLoading(false);
    }
  }
  async function getTransactionCommonSytemNotesData(limit, offset) {
    setLoading(true);
    try {
      const { data } = await getTransactionCommonSytemNotes(user.token, {
        id: params.docNo,
        limit,
        offset,
      });

      setLoading(false);
      return { rows: data.data.data, total: data.data.total, error: false };
    } catch (error) {
      console.log(error);
      setLoading(false);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      setLoading(false);
    }
  }
  return (
    <>
      <Box>
        <Grid container m={1} direction="row" alignItems="center">
          {/* <Grid item xs={12} sm={6}>
            <p className="tFormlabel">
              <u>AUCERNA LEGACY NO</u>
            </p>
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormGroup>
              <FormControlLabel
                control={<checkbox  disabled/>}
                label="RESUBMITTED BY SCRIPT"
              />
            </FormGroup>
          </Grid> */}
        </Grid>
        <Box
          sx={{
            maxWidth: { xs: "100%", sm: "100%", md: "100%" },
            bgcolor: "#fff",
            p: 1,
          }}
        >
          <Tabs
            value={tabIndex}
            // onChange={handleChange}
            onChange={(e, nv) => {
              setTabIndex(nv);
            }}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
            className="tabs-sub-bkg"
          >
            <Tab label="System Notes" />
            <Tab label="Active Workflows" style={{ margin: "10px" }} />
            <Tab label="Workflow History" />
            {/* <Tab label="Applied Rules" /> */}
          </Tabs>
          {/*-------------System Notes------------*/}
          <TabPanel value={tabIndex} index={0}>
            <Box py={1} mt={1}>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={4} md={3}>
                  <FormControl fullWidth size="small">
                    <InputLabel id="demo-simple-select-label">VIEW</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value=""
                      label="VIEW"
                    >
                      <MenuItem value="list">Default</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={4} md={3}>
                  <FormControl fullWidth size="small">
                    <InputLabel id="demo-simple-select-label">FIELD<span style={{color:"red"}}>*</span></InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value=""
                      label="FIELD"
                    >
                      <MenuItem value="list">List</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Box>
            <Box
              sx={{
                backgroundColor: "#bbd9e8",
                p: 1,
              }}
            >
              <Stack spacing={2} direction="row">
                <Button className="blue-button">Customize View</Button>
              </Stack>
            </Box>
            <AgGridPaginatedTable
              getTableRows={getTransactionCommonSytemNotesData}
              columns={commonSystemNotesTable}
              refreshCounter={0}
              perPage={5}
            />
          </TabPanel>
          {/*------------Active Workflows--------------*/}
          <TabPanel value={tabIndex} index={1}>
            <Box py={1} mt={1}>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={4} md={3}>
                  <FormControl fullWidth size="small">
                    <InputLabel id="demo-simple-select-label">VIEW</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value=""
                      label="VIEW"
                    >
                      <MenuItem value="list">Default</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Box>
            <Box
              sx={{
                backgroundColor: "#bbd9e8",
                p: 1,
              }}
            >
              <Stack spacing={2} direction="row">
                <Button className="blue-button">Customize View</Button>
                <Button className="blue-button">Refresh</Button>
              </Stack>
            </Box>
            <AgGridPaginatedTable
              //getTableRows={getTransactionShippingAddressData}
              columns={invoiceActiveWorkfowTables}
              refreshCounter={0}
            />
          </TabPanel>
          {/*------------Workflow History--------------*/}
          <TabPanel value={tabIndex} index={2}>
            <Box py={1} mt={1}>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={4} md={3}>
                  <FormControl fullWidth size="small">
                    <InputLabel id="demo-simple-select-label">VIEW</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value=""
                      label="VIEW"
                    >
                      <MenuItem value="list">Default</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Box>
            <Box
              sx={{
                backgroundColor: "#bbd9e8",
                p: 1,
              }}
            >
              <Stack spacing={2} direction="row">
                <Button className="blue-button">Customize View</Button>
                <Button className="blue-button">Refresh</Button>
              </Stack>
            </Box>
            <AgGridPaginatedTable
              //getTableRows={getTransactionShippingAddressData}
              columns={invoiceWorkflowHistoryTables}
              refreshCounter={0}
            />
          </TabPanel>
          {/*------------Applied Rules--------------*/}
          {/* <TabPanel value={tabIndex} index={3}>
            <Box>
            <AgGridPaginatedTable
              //getTableRows={getTransactionShippingAddressData}
              columns={invoiceAppliedRulesTable}
              refreshCounter={0}
            />
            </Box>
          </TabPanel> */}
        </Box>
      </Box>
    </>
  );
}
